import LoadingModal from '@components/atoms/modals/LoadingModal';
import { AnalyticsScreenName } from 'mh-client';
import { lazy, Suspense } from 'react';
import { Route } from 'react-router';
import ProtectedRoute from './components/ProtectedRoute';

const Names = AnalyticsScreenName.getInstance();

const AboutProperty = lazy(() => import('@pages/property/AboutProperty'));
const Property = lazy(() => import('@pages/property/Property'));
// const PropertyTour = lazy(() => import('@pages/property/PropertyTour'));
// const LegalDocuments = lazy(
//     () => import('@pages/property/PropertyLegalDocuments')
// );

export const PropertyRoutes = (
    <>
        {/* <Route
            path="/property/:id/legal"
            element={
                <ProtectedRoute
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <LegalDocuments />
                        </Suspense>
                    }
                />
            }
        /> */}
        <Route
            path="/property/:slug"
            element={
                <ProtectedRoute
                    accountStatus={[
                        'None',
                        'Pending',
                        'KycVerified',
                        'KycDeclined',
                        'Complete',
                    ]}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <Property />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.PROPERTY }}
            // loader={PropertyAPI.endpoints.getAllProperties.loader(store)}
        />
        <Route
            path="/property/:slug/about"
            element={
                <ProtectedRoute
                    accountStatus={[
                        'None',
                        'Pending',
                        'KycVerified',
                        'KycDeclined',
                        'Complete',
                    ]}
                    outlet={
                        <Suspense fallback={<LoadingModal />}>
                            <AboutProperty />
                        </Suspense>
                    }
                />
            }
            handle={{ screen_name: Names.ABOUT_PROPERTY }}
            // loader={PropertyAPI.endpoints.getAllProperties.loader(store)}
        />
        {/* <Route
            path="/property/tour"
            element={
                <Suspense fallback={<LoadingModal />}>
                    <PropertyTour />
                </Suspense>
            }
        /> */}
    </>
);
